// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2HbSB","checkboxCol":"Table_checkboxCol__KUiAH","emailCol":"Table_emailCol__l7PTz","actionCol":"Table_actionCol__3zcuL"};